// extracted by mini-css-extract-plugin
export var card = "_oy-0";
export var content = "_oy-2";
export var details = "_oy-3";
export var icon = "_oy-1";
export var iconBlue = "_oy-5";
export var iconBrand = "_oy-4";
export var iconGrayBlue = "_oy-6";
export var iconGreen = "_oy-7";
export var iconIndigo = "_oy-8";
export var iconOrange = "_oy-9";
export var iconPurple = "_oy-a";
export var iconRed = "_oy-b";
export var iconWarning = "_oy-c";